export default {
    props: {
        data: Object,
        definition: Object,
        contentType: String,
        formDefinition: Object,
        orginalDisplay: Object,
        htmlPrefix: String
    },

    data: function () {
        return {
            settings: {},
            className:"",
            defaultShow: true,
            name:""
        };
    },

    inject:[
        "errorEventBus",
        "errorComponentPath"
    ],

    created: function () {
        this.settings = this.definition.Settings;
        this.name = this.definition.Name;
        this.className = (this.settings.ClassNames || []).join(" ");
        this.handleChildrens();
    },

    computed:{
        childrenDisplay:function(){
            return this.settings.Childrens.map(x=>x.Display)
        }
    },

    methods:{
        handleChildrens(){
            this.settings.Childrens.forEach(x=> {  
                x.watcher = this.flatChildrenFields(x)
            });

            let self = this;

            this.settings.Childrens.forEach(x=> {  
                this.$watch(
                    "formDefinition",
                    (newVal, oldVal) =>{
                        let watcher = x.watcher;
                        let formDefinitionDisplays = watcher.map(watchfield => {
                            return newVal[watchfield]?.IsDisplay && self.orginalDisplay[watchfield];
                        });
                        x.Display = formDefinitionDisplays.includes(true);
                    },
                    {
                        deep:true
                    }
                );
                this.$watch("orginalDisplay",(newVal, oldVal) =>{
                    let watcher = x.watcher;
                    let formDefinitionDisplays = watcher.map(watchfield => {
                        return newVal[watchfield] && self.formDefinition[watchfield]?.IsDisplay;
                    });
                    x.Display = formDefinitionDisplays.includes(true);
                },
                {
                    deep:true,
                    immediate:true
                });
            });

            this.$watch("childrenDisplay",(newVal, oldVal) =>{
                self.defaultShow = (newVal||[]).includes(true);
            },
            {
                deep:true
            });
        },

        flatChildrenFields:function(Children){
            let fields = [];
            Children.Components.forEach(grandson=>{
                if(["qweCollapse","qweTabs","qweGrids","qweCard"].includes(grandson.FieldDefinition.Name)){
                    grandson.Settings.Childrens.forEach(x=> {
                        let ChildrenFields = this.flatChildrenFields(x);
                        fields = fields.concat(ChildrenFields);
                    });
                    
                }
                else {
                    fields.push(grandson.Name);
                }
            })
            return fields
        }
    }
};